import templateUrl from './new-menu-add.html';

export const newMenuAddComponent = {
    bindings: {
        resolve: '<',
        close: '&'
    },

    templateUrl,

    controller: class NewMenuAddComponent {
        constructor($state, NewMenuAddService, toastr) {
            'ngInject';

            this.$state = $state;
            this.newMenuAddService = NewMenuAddService;
            this.toastr = toastr;
        }

        $onInit() {
            this.details = {
                title: '',
                description: '',
                overview: '',
                menuId: parseInt(this.resolve.details.menuId)
            };
            this.disableButtons = false;
        }

        onSubmit() {
            this.disableButtons = true;
            this.newMenuAddService.addNewMenu(this.details)
                .then(data => {
                    this.toastr.success("New menu added successfully.");
                    this.close();
                    this.$state.reload();
                })
                .catch(err => {
                    //handle error
                    this.toastr.error(err);
                    this.disableButtons = false;
                });
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/feature-main-page-template/new-menu-add/new-menu-add.component.js